export const APP_CONSTANTS = {
  API_URL: "https://api.payerconnect.dev.zsservices.com",
};
